// Copyright © 2021 Move Closer
import { registerDirectives } from './directives';
import { registerFilters } from './filters';
export * from './directives';
export * from './filters';
/**
 * Register all Vue extensions.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnici@movecloser.pl>
 */
export function registerExtensions() {
    registerDirectives();
    registerFilters();
}
